import { createAsyncThunk } from "@reduxjs/toolkit";

import { MaxFileSizeEnum } from "core/enums";

import { fetchSomItem } from "./fetchSomItem";

export const uploadSomOfferJusts = createAsyncThunk("som/uploadJusts", async ({ files, offerId }, { rejectWithValue, dispatch, getState, extra }) => {
	const somId = getState().som.curItem.id;

	const promisesArr = [];

	for (const file of files) {
		if (file?.size > MaxFileSizeEnum.SOM_JUST) {
			return rejectWithValue("Размер файла превышает допустимый");
		}

		promisesArr.push(extra.apiSom.uploadJustFile({ file, somId, offerId }));
	}

	try {
		await Promise.all(promisesArr);
		dispatch(fetchSomItem({ itemId: somId }));
		return "Обоснования загружены";
	} catch (e) {
		return rejectWithValue(e);
	}
});
